// extracted by mini-css-extract-plugin
module.exports = {"label":"OrderInput_label__IK8Jp","input":"OrderInput_input__33Cv6"};